<template>
	<div>
		<Loading v-if="loading"/>
		<div v-else class="matching">
			<div
				class="matching--category"
				v-for="item in defaultMatchingItems"
				:key="item.id"
			>
				<b-row align-v="center">
					<b-col md="3">
						<h3>{{ item.label }}</h3>
					</b-col>
					<b-col md="9">
						<div class="matching--category-items matching--category-items-no-item-x-padding">
							<Item
								:score="item.score"
								:max-score="item.maxScore"
								class="force--bg-color-transparent"
								:with-percentage="false"
								:info-text="item.infoText"
							/>
						</div>
					</b-col>
				</b-row>
			</div>
			<div class="job-vita mt-4">
				<Grid
					v-for="grid in vita.grids.filter(g => g.hasData)"
					:key="grid.id"
					:grid="grid"
					:job-profile-id="jobProfileId"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import Item from "@/vue/common/matching/Item";
import _ from "lodash";
import Matching from "@/api/job/Matching";
import {getDefaultItems} from "@/helper/job/Matching";
import Grid from "@/vue/application/job/vita/Grid.vue";

export default {

	components: {
		Grid,
		Loading,
		Item,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
	},

	mounted ()
	{
		this.loadMatching();
	},

	data ()
	{
		return {
			loading: true,
			matching: null,
			vita: null,
		};
	},

	computed: {
		defaultMatchingItems ()
		{
			return getDefaultItems(this.matching);
		},
		grouped ()
		{
			let grouped = [];

			_.forEach(this.matching.items, item =>
			{
				let group = _.find(grouped, g => g.category.id === item.category.id);

				if (!group)
				{
					group = {
						category: item.category,
						items: []
					};

					grouped.push(group);
				}

				group.items.push(item);
			});

			return grouped;
		}
	},

	methods: {
		async loadMatching ()
		{
			this.loading = true;

			const response = await new Matching()
				.setJob(this.jobId)
				.setJobProfile(this.jobProfileId)
				.setMarkAsSeen(true)
				.call();

			this.matching = response.data.matching;
			this.vita = response.data.vita;

			this.loading = false;

			this.$emit('loaded');
		}
	}
}
</script>
